const BANNER_ACTIONS = {
  DASHBOARD: 'dashboard-vp-banner-collaborative-manufacturing-click-CTA',
  COMMUNITY_FEATURED: 'community-featured-vp-banner-click-CTA-start-project',
  COMMUNITY_PROJECTS: 'community-projects-vp-banner-click-learn',
  COMMUNITY_TASKS: 'community-tasks-vp-banner-click-learn',
  COMMUNITY_TOPICS: 'community-topics-vp-banner-click-learn',
  PROJECT_SIGNED_IN:
    'community-projects-signed-in-user-vp-banner-make-part-click-CTA',
  PROJECT_SIGNED_OUT:
    'community-project-visitors-vp-banner-collaborative-manufacturing-click-learn',
  PROJECT_FILES: 'community-project-files-vp-banner-make-part-click-CTA',
  FILES: 'my-files-vp-banner-share-file-click-CTA',
  PROJECTS: 'my-projects-vp-banner-start-project-click-CTA',
  RFQS: 'my-rfqs-vp-banner-make-part-click-CTA',
  ORDERS: 'my-orders-vp-banner-manufacture-click-CTA',
};

export default BANNER_ACTIONS;
